// ============================================================
// G3：录制漫游按钮（开录 → 播放漫游/路径 → 再点停止并下载 webm）
// ============================================================
import { useState } from 'react';
import { Button, Tooltip, message } from 'antd';
import { VideoCameraAddOutlined, VideoCameraOutlined } from '@ant-design/icons';
import useSceneStore from '../../stores/sceneStore';
import { downloadSceneRecording, isSceneRecordingSupported, startSceneRecording, stopSceneRecording } from '../../utils/sceneRecorder';
import { buildExportFilename } from '../../utils/imageExport';

export default function RecordRoamButton() {
  const [recording, setRecording] = useState(false);
  const sceneName = useSceneStore((s) => s.currentScene?.name ?? '场景');

  const toggle = async () => {
    if (!recording) {
      if (!isSceneRecordingSupported()) {
        message.error('当前浏览器不支持画布录制（需 Chromium 系内核）');
        return;
      }
      if (!startSceneRecording()) {
        message.error('录制启动失败');
        return;
      }
      setRecording(true);
      message.info('开始录制：请播放「漫游/路径相机」，完成后再次点击停止并下载');
      return;
    }
    const blob = await stopSceneRecording();
    setRecording(false);
    if (!blob) {
      message.warning('未获得录制内容');
      return;
    }
    const base = buildExportFilename(sceneName, 0, 0, 'png').replace('-0x0.png', '');
    downloadSceneRecording(blob, `${base}-漫游.webm`);
    message.success(`已导出漫游视频（${(blob.size / 1024 / 1024).toFixed(1)}MB）`);
  };

  return (
    <Tooltip title={recording ? '停止录制并下载（webm）' : '录制漫游视频：先播放漫游/路径相机再停止'}>
      <Button
        size="small"
        danger={recording}
        icon={recording ? <VideoCameraOutlined /> : <VideoCameraAddOutlined />}
        onClick={() => void toggle()}
      >
        {recording ? '停止录制' : '录制漫游'}
      </Button>
    </Tooltip>
  );
}
